import { render, staticRenderFns } from "./PricingJewellersBlockOpenMarket.vue?vue&type=template&id=4755f93c"
import script from "./PricingJewellersBlockOpenMarket.vue?vue&type=script&lang=js"
export * from "./PricingJewellersBlockOpenMarket.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports